const vuePlaceholder = {
    template: '',
    controller: 'VuePlaceholderCtrl',
};

const registerRoutes = function ($routeProvider) {
    $routeProvider.when('/', { templateUrl: 'partials/epos/index.html', controller: 'EposIndexCtrl' });
    $routeProvider.when('/device', { templateUrl: 'partials/device.html', controller: 'DeviceCtrl' });

    $routeProvider.when('/accounts', vuePlaceholder);
    $routeProvider.when('/accounts/:accountID', vuePlaceholder);

    $routeProvider.when('/memberships/:membershipRef/:memberRef', vuePlaceholder);
    $routeProvider.when('/memberships/:membershipRef', vuePlaceholder);

    $routeProvider.when('/orders/:bookingRef/:wasBarcodeScan',
        {
            templateUrl: 'partials/orders/order-details.html',
            controller: 'OrderDetailCtrl',
        });

    $routeProvider.when('/sell', { templateUrl: 'partials/sell/index.html', controller: 'SellCtrl' });

    $routeProvider.when('/dojo-reports', vuePlaceholder);
    $routeProvider.when('/login', vuePlaceholder);
    $routeProvider.when('/orders', vuePlaceholder);

    $routeProvider.when('/report', { redirectTo: '/reports' });
    $routeProvider.when('/reports', vuePlaceholder);
    $routeProvider.when('/reports/:tradingSessionID', vuePlaceholder);

    $routeProvider.when('/today', vuePlaceholder);
    $routeProvider.when('/ui-test', vuePlaceholder);

    $routeProvider.when('/403', { templateUrl: 'partials/errors/403.html', controller: 'ErrorCtrl' });

    $routeProvider.otherwise({ redirectTo: '/' });
};

module.exports = registerRoutes;
